<section class="about-section" #aboutSection>
    <div class="about-overlay"></div>

    <div class="about-container">

        <!-- Wrapper que agrupa todo y recibe la animación -->
        <div class="about-floating-box animate-on-scroll" [class.visible]="isVisible">

            <div class="about-content">
                <!-- Columna izquierda: Texto -->
                <div class="about-text">
                    <h2 class="about-title">Sobre nosotros</h2>
                    <p class="about-description">
                        Somos LightCap Group, una firma fundada por agentes del mercado de capitales con amplia
                        experiencia
                        en asesoramiento a personas y PyMEs. Nuestra misión es ayudarte a planificar, proteger y
                        potenciar
                        tu dinero. Sin letra chica, sin productos enlatados, sin conflictos de interés.
                    </p>
                </div>

                <!-- Columna derecha: Imagen -->
                <div class="about-image-container">
                    <div class="about-image-wrapper">
                        <img src="/assets/Tarjetas servicios/4 capacitacion.jpg" alt="Equipo LightCap Group"
                            class="about-image" />
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>

<!-- Componentes inferiores -->
<app-team></app-team>
<app-specialists-network></app-specialists-network>
<app-partners></app-partners>
<app-contact-form></app-contact-form>